import type { BrandType } from '../types';

export function isValidBrand(value: unknown): value is BrandType {
  return value === 'WMG' || value === 'ADA';
}
